import { useState, useEffect } from "preact/hooks";

const STORAGE_KEY = "festapp:app-prompt-dismissed";

function isMobile(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod|Android/i.test(ua);
}

export function useAppPrompt(dynamicLink: string | undefined) {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    if (!dynamicLink) return;
    if (!isMobile()) return;

    try {
      const dismissed = localStorage.getItem(STORAGE_KEY);
      if (!dismissed) {
        setShowPrompt(true);
      }
    } catch {
      // localStorage not available
    }
  }, [dynamicLink]);

  const dismissPrompt = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "true");
    } catch {
      // localStorage not available
    }
    setShowPrompt(false);
  };

  const openApp = () => {
    if (dynamicLink) {
      window.location.href = dynamicLink;
    }
  };

  return { showPrompt, dismissPrompt, openApp };
}
